import { fixedSetGrants, type PermissionSetEntity, type PermissionSetPermission } from '@omnea-digital/authz-model'
import type { RecordGrantConfiguration } from './useUpdateRecordAccessGrant'

/** Whether a grant confers the permission. A set the catalogue does not hold confers nothing known. */
export const grantConfers = (
  entity: PermissionSetEntity,
  configuration: RecordGrantConfiguration,
  permission: PermissionSetPermission,
  setPermissionsById: ReadonlyMap<string, readonly string[]>
): boolean => {
  switch (configuration.kind) {
    case 'fixed':
      return fixedSetGrants(entity, configuration.level, permission)
    case 'custom':
      return setPermissionsById.get(configuration.permissionSetId)?.includes(permission) ?? false
  }
}
